// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	ServiceAddress: 'service-address',
	ReportAddress: 'report-address',
	BusinessAddress: 'business-address',
	ServiceAddress1: 'service-address-1',
	ReportAddress1: 'report-address-1',
	BusinessAddress1: 'business-address-1',
	SetServiceAddressButton: 'set-service-address-button',
	ApplyThisAddressToAllClientsButton:
		'apply-this-address-to-all-clients-button',
	SetServiceAddressButton1: 'set-service-address-button-1',
	SetReportAddressButton: 'set-report-address-button',
	ApplyThisAddressToAllClientsButton1:
		'apply-this-address-to-all-clients-button-1',
	SetReportAddressButton1: 'set-report-address-button-1',
	ReportAddressSameAsServiceAddressCheckbox:
		'report-address-same-as-service-address-checkbox',
	ReportAddressSameAsServiceAddressCheckbox1:
		'report-address-same-as-service-address-checkbox-1',
	BirthdateDatePicker: 'birthdate-date-picker',
	PowerOfAttorneyDateDatePicker: 'power-of-attorney-date-date-picker',
	DateOfDeathDatePicker: 'date-of-death-date-picker',
	TitleDropdown: 'title-dropdown',
	FirstName: 'first-name',
	Input: 'input',
	LastName: 'last-name',
	PreferredName: 'preferred-name',
	InstrumentNumber: 'instrument-number',
	InstrumentNumber1: 'instrument-number-1',
	CellPhone: 'cell-phone',
	HomePhone: 'home-phone',
	WorkPhone: 'work-phone',
	Email: 'email',
	Occupation: 'occupation',
	PrimarySalutation: 'primary-salutation',
	EnvelopeSalutation: 'envelope-salutation',
	Input1: 'input-1',
	PrimarySalutationInputWrapper: 'primary-salutation-input-wrapper',
	EnvelopeSalutationInputWrapper: 'envelope-salutation-input-wrapper',
	GenderRadioGroup: 'gender-radio-group',
	CanadianResidentRadioGroup: 'canadian-resident-radio-group',
	ResidentStatusRadioGroup: 'resident-status-radio-group',
	PersonalDetailsSection: 'personal-details-section',
	ContactDetailsSection: 'contact-details-section',
	AddressesSection: 'addresses-section',
	SalutationsSection: 'salutations-section',
	RepresentationTypeSelect: 'representation-type-select',
	EstateStatusSelect: 'estate-status-select',
	PrimarySalutationTypeSelect: 'primary-salutation-type-select',
	EnvelopeSalutationTypeSelect: 'envelope-salutation-type-select',
	TextArea: 'text-area',
	Option: 'option',
	Option1: 'option-1',
	Option2: 'option-2',
	Option3: 'option-3',
	Option4: 'option-4',
	Option5: 'option-5',
	Option6: 'option-6',
	Option7: 'option-7',
	Option8: 'option-8',
	Option9: 'option-9',
	Option10: 'option-10',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
